import React from 'react'
import { Row, Column, Box } from 'components/Layout'
import { Button } from 'components/Button'
import { Fade, SlideIn } from 'components/Transitions'
import { Modal, Background } from 'components/Overlay'

import { CreateNewAppForm } from '../../containers/Forms'

const CreateNewAppModal = ({ closePortal }) =>
	<Fade>
		<Background onClick={closePortal}>
			<SlideIn from="bottom">
				<Modal
					onClick={e => {
						e.stopPropagation()
					}}
				>
					<Row>
						<Column width={6}>
							<Box
								header={'Creating new app'}
								info={
									<Button
										onClick={e => {
											e.stopPropagation()
											closePortal()
										}}
										icon="close"
										type="ghost"
									/>
								}
								body={
									<CreateNewAppForm
										closePortal={closePortal}
									/>
								}
							/>
						</Column>
					</Row>
				</Modal>
			</SlideIn>
		</Background>
	</Fade>

CreateNewAppModal.propTypes = {
	closePortal: React.PropTypes.func
}

export default CreateNewAppModal



// WEBPACK FOOTER //
// ./src/views/Modals/CreateNewAppModal.js